export default "__VITE_ASSET__Cp$RVkum__"